import config from "@Config/index";
import { isApp } from "hooks/useIsApp";

// eslint-disable-next-line import/prefer-default-export
export const isClientSideAuthEnabled = () =>
  config?.IS_CHINA_APP === true || config?.IS_WHITELABEL_APP === true || isApp();
